export default __webpack_public_path__ + "static/media/sendinblue-logo.846cc56d.png";